import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLogin } from "@/hooks/useLogin";
import { consumeLoginRedirect } from "@/utils/auth";
import { LoginPresenter } from "./presenter";
import { useFeatureFlags } from "@/configs/featureFlag";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { LoginFormSchema, type LoginFormData } from "./types/schemas";

const LoginContainer: React.FC = () => {
  // ---
  // hooks群
  // ---
  const navigate = useNavigate();
  const { isLoggedIn, login } = useLogin();
  const [userIp, setIp] = useState<string>("");
  const { mypageTop } = useFeatureFlags();

  const loginForm = useForm<LoginFormData>({
    mode: "all",
    defaultValues: {
      email: "",
      password: "",
    },
    resolver: zodResolver(LoginFormSchema),
  });

  // ---
  // useEffect群
  // ---
  const getIp = async (): Promise<void> => {
    // 外部APIが機能しないときはundefinedとして返す
    try {
      const response = await fetch("https://api.ipify.org/?format=json");
      const data = (await response.json()) as Record<string, string>;
      setIp(data.ip);
    } catch (e) {
      setIp("undefined");
    }
  };

  useEffect(() => {
    // IPアドレスを取得
    (async () => {
      await getIp();
    })();
    // ログイン済みの場合はリダイレクト先または一覧画面に遷移させる
    if (isLoggedIn) {
      const redirect = consumeLoginRedirect();
      navigate(redirect ?? (mypageTop ? "/mypage" : "/feed"));
    }
  }, [isLoggedIn]);

  // ---
  // function群
  // ---
  const handleSubmit = async (
    data: LoginFormData,
    cancelLoading: () => void
  ): Promise<void> => {
    await login(data.email, data.password, userIp, cancelLoading);
  };

  return <LoginPresenter loginForm={loginForm} handleSubmit={handleSubmit} />;
};

export { LoginContainer };
